import { Box } from "@chakra-ui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ContractTaskDto } from "../../../../../../autogen/bff-api";
import { EditButton } from "../EditButton";
import { EditTitle } from "./EditTitle";

interface Props {
  task: ContractTaskDto;
}

export const Title = ({ task }: Props) => {
  const { t } = useTranslation();
  const [isEditing, setIsEditing] = useState(false);

  return (
    <Box mt="10px">
      {!isEditing && (
        <>
          {task.title}
          {task.canEdit && <EditButton name="edit-title-button" label={t("Edit title")} onClick={() => setIsEditing(true)} />}
        </>
      )}
      {isEditing && (
        <EditTitle
          task={task}
          onEditComleted={() => setIsEditing(false)}
          onCancel={() => setIsEditing(false)}
        />
      )}
    </Box>
  );
};
